export function reverseValue(value) {
  if (value > 0) {
    return -Math.abs(value);
  }else{
    return Math.abs(value)
  }
}
